import LoadingOverlay from "@/components/LoadingOverlay";

const PageLazyLoading = () => {
  return <LoadingOverlay loading />;
};

export default PageLazyLoading;
